import React from 'react';
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'


const generateExternalUrl = (symbol, tx) => {
  if (symbol === 'ETH') {
    return <span><a href={`https://etherscan.io/tx/${tx}`} target='_blank'>{tx}</a></span>
  } else if (symbol === 'BTC') {
    return <span><a href={`https://blockchain.info/tx/${tx}`} target='_blank'>{tx}</a></span>
  } else {
    return (
      <span></span>
    )
  }
}

const TransactionList = props => {
  if (!props.transactions) {
    return (
      <div className='broad'>Loading...</div>
    );
  }

  if (props.transactions.length === 0) {
    return (
      <div className='empty'>
        No transactions...
      </div>
    );
  }

  return (
    <div>
      <table className="dataTable">
        <thead>
          <tr>
            <th>key</th>
            <th>created</th>
            <th>type</th>
            <th>status</th>
            <th>sender account</th>
            <th>recipient account</th>
            <th>amount</th>
            <th>transaction hash</th>
          </tr>
        </thead>
        <tbody>
          {
            props.transactions.map(transaction => {
              return (
                <tr key={transaction.key}>
                  <td>{transaction.key}</td>
                  <td>{dateHelper.Formatter.toLocalString(transaction.created)}</td>
                  <td>{transaction.type}</td>
                  <td>{transaction.status}</td>
                  <td>{transaction.sender_account}</td>
                  <td>{transaction.recipient_account}</td>
                  <td>{numberHelper.Formatter.toDecimal(transaction.amount)}</td>
                  <td>{(transaction.details && transaction.details.transaction_hash) ? generateExternalUrl(transaction.symbol, transaction.details.transaction_hash) : null}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default TransactionList;



// WEBPACK FOOTER //
// ./src/components/widgets/TransactionList.js